// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__Uq7Q6","spinner":"Loader_spinner__Y73vt","spin":"Loader_spin__Soegw","text":"Loader_text__YDTe9"};